import React, { Component } from "react";

class Roles extends Component {
  state = {};
  render() {
    return <h1>Roles</h1>;
  }
}

export default Roles;
